// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Types
type $Props = $Translate & {
  value: number;
};

const LabelQuantityView = function ({
  t,
  value,
}: $Props) {
  return (
    <>
      <span className={'LabelQuantity text-right mr-1'}>
        <span className={'hidden sm:inline'}>
          {t('Items on list')}
        </span>
        <span className={'sm:hidden'}>
          {t('Qty.')}
        </span>
        <span>
          {': '}
        </span>
      </span>
      <span className={'text-gray-600'}>
        {value}
      </span>
    </>
  );
};

export default LabelQuantityView;
